<!-- パスワード入力フィールドコンポーネント -->
<template>
    <dl class="formContainer" :class="classappend">
        <dt>
            <slot name="label"></slot>
        </dt>
        <dd>
            <template v-if="validate.$error">
                <span v-if="!validate.required" class="errNote">{{ label }}を入力してください。</span>
                <span v-if="!validate.passwordRule && hasPasswordRule" class="errNote">{{ label }}は大文字英・小文字英・数字・記号の中から3種以上で入力してください。</span>
                <span v-if="(!validate.minLength || !validate.maxLength) && hasPasswordLength" class="errNote">
                    パスワードは{{ validate.$params.minLength.min }}文字以上{{ validate.$params.maxLength.max }}文字以下で入力してください。
                </span>
                <span v-if="!validate.sameAs && name == 'confirm'" class="errNote">新しいパスワードが確認欄のパスワードと一致していません。</span>
            </template>
            <div class="pswdShowHide">
                <input v-model="validate.$model"
                       :name="name"
                       :type="inputType"
                       :placeholder="placeholder"
                       class="regular">
                <i :class="iconClass" @click="toggle" @keydown.enter="toggle" tabIndex="0" aria-label="パスワード表示/非表示">パスワード表示/非表示</i>
            </div>
            <slot name="note"></slot>
        </dd>
    </dl>
</template>

<script>
export default {
    name: 'PasswordField',
    data() {
        return {
            isShowPassword: false,
        }
    },
    computed: {
        iconClass: function(){
            const klass = this.isShowPassword? 'show': '';
            return ['pwSwitch', klass];
        },
        inputType: function(){
            return this.isShowPassword? 'text': 'password';
        },
        hasPasswordRule: function(){
            return !(typeof this.validate.passwordRule === 'undefined');
        },
        hasPasswordLength: function(){
            return !(typeof this.validate.minLength === 'undefined');
        }
    },
    props: {
        classappend: {
            type: Array,
            default: function(){
                return []
            }
        },
        label: {
            type: String,
            required: true
        },
        placeholder: {
            type: String,
            default: ''
        },
        name: {
            type: String,
            required: true
        },
        validate: {
            type: Object,
            required: true
        }
    },
    methods: {
        toggle: function(){
            this.isShowPassword = !this.isShowPassword;
        }
    }
}
</script>
